module.exports = __webpack_public_path__ + "img/10.5af2ae59.jpg";